import {NgModule} from '@angular/core';

@NgModule({
    exports: [
    ],
    declarations: [
    ]
})
export class PipeModule {}
